import { useContext } from "react";
import { BehaviorContext } from "../context/context";

const useBehaviorContext = () => {
  const context = useContext(BehaviorContext);
  if (!context)
    throw new Error(
      "useBehaviorContext must be used within a BehaviorProvider"
    );
  return context;
};

export default useBehaviorContext;
